var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zl-button"},[_c('button',{staticClass:"again",style:({height:_vm.height+'px',background:_vm.background,
        'border-radius':(_vm.height/2 )+'px',color:_vm.color,
        'border':_vm.border})},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }